import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useErrorContext } from '../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import { getFromLS } from '../../shared/utils/functions/storage/getFromLS.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import { isDisplayOrderPriorityForWeb2 } from '../../shared/utils/functions/isDisplayOrderPriorityForWeb2/isDisplayOrderPriorityForWeb2.js';
import { LAST_USED_WALLET } from '../../utils/constants/localStorage.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { ErrorContainer } from '../../components/ErrorContainer/ErrorContainer.js';
import { Divider } from '../../components/Divider/Divider.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';
import { walletListBuilder } from '../../utils/functions/walletListBuilder/index.js';
import { LoginWithEmailForm } from './components/LoginWithEmailForm/LoginWithEmailForm.js';
import { NUMBER_OF_WALLETS, LoginWithEmailWalletList } from './components/LoginWithEmailWalletList/LoginWithEmailWalletList.js';

const LoginWithEmailView = () => {
    var _a;
    const { error } = useErrorContext();
    const { authorizationViewDisplayOrder, wallets, projectSettings } = useInternalDynamicContext();
    const { walletsFilter, signWithEmailWalletName, loginWithEmail } = useInternalDynamicContext();
    const { numberOfWallets, walletsList } = walletListBuilder({
        inputList: wallets,
        isWalletConnectList: false,
        lastUsedWalletName: getFromLS(LAST_USED_WALLET),
        loginWithEmail,
        numberOfWalletsToShow: NUMBER_OF_WALLETS,
        searchFilter: undefined,
        signWithEmailWalletName,
        walletsFilter,
    });
    const dividerText = isDisplayOrderPriorityForWeb2(authorizationViewDisplayOrder)
        ? 'Or continue with a wallet'
        : 'Or use email';
    return (jsxs("div", Object.assign({ className: 'login-with-email__container' }, { children: [error && jsx(ErrorContainer, { children: error }), jsxs("div", Object.assign({ className: classNames('login-with-email__scroll', {
                    'login-with-email__scroll--email-first': isDisplayOrderPriorityForWeb2(authorizationViewDisplayOrder),
                }), "data-testid": 'login-with-email-scroll' }, { children: [numberOfWallets &&
                        walletsList.length &&
                        !((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design.modal) === null || _a === void 0 ? void 0 : _a.emailOnly) ? (jsxs(Fragment, { children: [jsx(LoginWithEmailWalletList, { walletsList: walletsList, numberOfWallets: numberOfWallets }), jsx(Divider, { text: dividerText })] })) : null, jsx(LoginWithEmailForm, {})] }))] })));
};

export { LoginWithEmailView };
